import { onDestroy } from 'svelte';

/** Must be called during component init. @returns whether the owning component is still mounted */
export function useAlive(): () => boolean {
	let alive = true;
	onDestroy(() => {
		alive = false;
	});
	return () => alive;
}
